/**
 * 基盤Service
 */
export class BaseService {
    /**
     * @constructor
     * @param {ng.IHttpService} $http - http
     */
    constructor(protected $http: ng.IHttpService) {

    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/service/BaseService.ts
 **/